import { WaitlistDialog } from "@/components/WaitlistDialog";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export function ValueStack() {
  const { t } = useI18n();

  const items = [
    { labelKey: "valuestack.copywriter", cost: "$500/mo" },
    { labelKey: "valuestack.videoEditor", cost: "$1,000/mo" },
    { labelKey: "valuestack.adManager", cost: "$2,000/mo" },
    { labelKey: "valuestack.designTool", cost: "$50/mo" },
  ];

  return (
    <section className="px-4 md:px-6 pt-12 md:pt-16">
      <div className="max-w-2xl mx-auto rounded-3xl border-2 border-primary bg-card p-6 md:p-8 glow-orange">
        <h3 className="text-2xl md:text-3xl font-bold text-center mb-6">
          {t("valuestack.title")} <span className="text-gradient-orange">{t("valuestack.titleHighlight")}</span> {t("valuestack.titleEnd")}
        </h3>

        <ul className="space-y-3 mb-5">
          {items.map((it) => (
            <li
              key={it.labelKey}
              className="flex items-center justify-between text-base md:text-lg"
            >
              <span className="text-foreground">{t(it.labelKey)}</span>
              <span className="text-muted-foreground line-through">{it.cost}</span>
            </li>
          ))}
        </ul>

        <div className="border-t border-border pt-4 flex items-center justify-between text-base md:text-lg font-medium">
          <span className="text-muted-foreground">{t("valuestack.total")}</span>
          <span className="text-foreground font-bold">$3,550/mo</span>
        </div>

        <div className="mt-6 text-center">
          <p className="text-3xl md:text-4xl font-bold text-gradient-orange">
            {t("valuestack.starter")}
          </p>
          <p className="mt-2 text-base md:text-lg text-foreground">
            {t("valuestack.savings")}
          </p>
        </div>

        <div className="mt-6 flex justify-center">
          <WaitlistDialog>
            <button
              style={{ backgroundColor: "#e8721a", color: "#ffffff" }}
              className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold hover:brightness-110 transition"
            >
              {t("valuestack.cta")} <ArrowRight className="w-4 h-4" />
            </button>
          </WaitlistDialog>
        </div>
      </div>
    </section>
  );
}
